import _asyncToGenerator from "/Users/appsmaven/Desktop/Neeraj/Scriptively/Web_Scriptively/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/Users/appsmaven/Desktop/Neeraj/Scriptively/Web_Scriptively/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/appsmaven/Desktop/Neeraj/Scriptively/Web_Scriptively/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/appsmaven/Desktop/Neeraj/Scriptively/Web_Scriptively/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useState as e, useRef as t, useEffect as n } from "react";
var _o = function o() {
  return (_o = Object.assign || function (e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) for (var r in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    return e;
  }).apply(this, arguments);
};
function r(e, t, n, o) {
  return new (n || (n = Promise))(function (r, i) {
    function a(e) {
      try {
        c(o.next(e));
      } catch (e) {
        i(e);
      }
    }
    function s(e) {
      try {
        c(o.throw(e));
      } catch (e) {
        i(e);
      }
    }
    function c(e) {
      var t;
      e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
        e(t);
      })).then(a, s);
    }
    c((o = o.apply(e, t || [])).next());
  });
}
function i(e, t) {
  var n,
    o,
    r,
    i,
    a = {
      label: 0,
      sent: function sent() {
        if (1 & r[0]) throw r[1];
        return r[1];
      },
      trys: [],
      ops: []
    };
  return i = {
    next: s(0),
    throw: s(1),
    return: s(2)
  }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
    return this;
  }), i;
  function s(i) {
    return function (s) {
      return function (i) {
        if (n) throw new TypeError("Generator is already executing.");
        for (; a;) try {
          if (n = 1, o && (r = 2 & i[0] ? o.return : i[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, i[1])).done) return r;
          switch (o = 0, r && (i = [2 & i[0], r.value]), i[0]) {
            case 0:
            case 1:
              r = i;
              break;
            case 4:
              return a.label++, {
                value: i[1],
                done: !1
              };
            case 5:
              a.label++, o = i[1], i = [0];
              continue;
            case 7:
              i = a.ops.pop(), a.trys.pop();
              continue;
            default:
              if (!(r = a.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                a = 0;
                continue;
              }
              if (3 === i[0] && (!r || i[1] > r[0] && i[1] < r[3])) {
                a.label = i[1];
                break;
              }
              if (6 === i[0] && a.label < r[1]) {
                a.label = r[1], r = i;
                break;
              }
              if (r && a.label < r[2]) {
                a.label = r[2], a.ops.push(i);
                break;
              }
              r[2] && a.ops.pop(), a.trys.pop();
              continue;
          }
          i = t.call(e, a);
        } catch (e) {
          i = [6, e], o = 0;
        } finally {
          n = r = 0;
        }
        if (5 & i[0]) throw i[1];
        return {
          value: i[0] ? i[1] : void 0,
          done: !0
        };
      }([i, s]);
    };
  }
}
function a() {
  for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
  var o = Array(e),
    r = 0;
  for (t = 0; t < n; t++) for (var i = arguments[t], a = 0, s = i.length; a < s; a++, r++) o[r] = i[a];
  return o;
}
var s,
  c = l;
function l() {}
l.mixin = function (e) {
  var t = e.prototype || e;
  t.isWildEmitter = !0, t.on = function (e, t, n) {
    this.callbacks = this.callbacks || {};
    var o = 3 === arguments.length,
      r = o ? arguments[1] : void 0,
      i = o ? arguments[2] : arguments[1];
    return i._groupName = r, (this.callbacks[e] = this.callbacks[e] || []).push(i), this;
  }, t.once = function (e, t, n) {
    var o = this,
      r = 3 === arguments.length,
      i = r ? arguments[1] : void 0,
      a = r ? arguments[2] : arguments[1];
    function s() {
      o.off(e, s), a.apply(this, arguments);
    }
    return this.on(e, i, s), this;
  }, t.releaseGroup = function (e) {
    var t, n, o, r;
    for (t in this.callbacks = this.callbacks || {}, this.callbacks) for (n = 0, o = (r = this.callbacks[t]).length; n < o; n++) r[n]._groupName === e && (r.splice(n, 1), n--, o--);
    return this;
  }, t.off = function (e, t) {
    this.callbacks = this.callbacks || {};
    var n,
      o = this.callbacks[e];
    return o ? 1 === arguments.length ? (delete this.callbacks[e], this) : (-1 !== (n = o.indexOf(t)) && (o.splice(n, 1), 0 === o.length && delete this.callbacks[e]), this) : this;
  }, t.emit = function (e) {
    this.callbacks = this.callbacks || {};
    var t,
      n,
      o,
      r = [].slice.call(arguments, 1),
      i = this.callbacks[e],
      a = this.getWildcardCallbacks(e);
    if (i) for (t = 0, n = (o = i.slice()).length; t < n && o[t]; ++t) o[t].apply(this, r);
    if (a) for (n = a.length, t = 0, n = (o = a.slice()).length; t < n && o[t]; ++t) o[t].apply(this, [e].concat(r));
    return this;
  }, t.getWildcardCallbacks = function (e) {
    this.callbacks = this.callbacks || {};
    var t,
      n,
      o = [];
    for (t in this.callbacks) n = t.split("*"), ("*" === t || 2 === n.length && e.slice(0, n[0].length) === n[0]) && (o = o.concat(this.callbacks[t]));
    return o;
  };
}, l.mixin(l), "undefined" != typeof window && (s = window.AudioContext || window.webkitAudioContext);
var u = null,
  f = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {},
  h = !!(f === f.window && f.URL && f.Blob && f.Worker);
function d(e, t) {
  var n,
    o = this;
  if (t = t || {}, h) return n = e.toString().trim().match(/^function\s*\w*\s*\([\w\s,]*\)\s*{([\w\W]*?)}$/)[1], new f.Worker(f.URL.createObjectURL(new f.Blob([n], {
    type: "text/javascript"
  })));
  this.self = t, this.self.postMessage = function (e) {
    setTimeout(function () {
      o.onmessage({
        data: e
      });
    }, 0);
  }, setTimeout(e.bind(t, t), 0);
}
d.prototype.postMessage = function (e) {
  var t = this;
  setTimeout(function () {
    t.self.onmessage({
      data: e
    });
  }, 0);
};
var p = d;
var g = /*#__PURE__*/function () {
  function g(e, t) {
    var _this = this;
    _classCallCheck(this, g);
    this.config = _objectSpread({
      bufferLen: 4096,
      numChannels: 1,
      mimeType: "audio/wav"
    }, t), this.recording = !1, this.callbacks = {
      getBuffer: [],
      exportWAV: []
    }, this.context = e.context, this.node = (this.context.createScriptProcessor || this.context.createJavaScriptNode).call(this.context, this.config.bufferLen, this.config.numChannels, this.config.numChannels), this.node.onaudioprocess = function (e) {
      if (_this.recording) {
        for (var t = [], n = 0; n < _this.config.numChannels; n++) t.push(e.inputBuffer.getChannelData(n));
        _this.worker.postMessage({
          command: "record",
          buffer: t
        });
      }
    }, e.connect(this.node), this.node.connect(this.context.destination);
    this.worker = new p(function () {
      var e,
        t,
        n,
        o = 0,
        r = [];
      function i() {
        for (var _e = 0; _e < t; _e++) r[_e] = [];
      }
      function a(e, t) {
        var n = new Float32Array(t),
          o = 0;
        for (var _t = 0; _t < e.length; _t++) n.set(e[_t], o), o += e[_t].length;
        return n;
      }
      function s(e, t, n) {
        for (var _o2 = 0; _o2 < n.length; _o2++) e.setUint8(t + _o2, n.charCodeAt(_o2));
      }
      this.onmessage = function (c) {
        switch (c.data.command) {
          case "init":
            l = c.data.config, e = l.sampleRate, t = l.numChannels, i(), n = e > 48e3 ? 48e3 : e;
            break;
          case "record":
            !function (e) {
              for (var n = 0; n < t; n++) r[n].push(e[n]);
              o += e[0].length;
            }(c.data.buffer);
            break;
          case "exportWAV":
            !function (i) {
              var c,
                l = [];
              for (var _e2 = 0; _e2 < t; _e2++) l.push(a(r[_e2], o));
              c = 2 === t ? function (e, t) {
                var n = e.length + t.length,
                  o = new Float32Array(n),
                  r = 0,
                  i = 0;
                for (; r < n;) o[r++] = e[i], o[r++] = t[i], i++;
                return o;
              }(l[0], l[1]) : l[0];
              var u = function (e) {
                  var o = new ArrayBuffer(44 + 2 * e.length),
                    r = new DataView(o);
                  return s(r, 0, "RIFF"), r.setUint32(4, 36 + 2 * e.length, !0), s(r, 8, "WAVE"), s(r, 12, "fmt "), r.setUint32(16, 16, !0), r.setUint16(20, 1, !0), r.setUint16(22, t, !0), r.setUint32(24, n, !0), r.setUint32(28, 4 * n, !0), r.setUint16(32, 2 * t, !0), r.setUint16(34, 16, !0), s(r, 36, "data"), r.setUint32(40, 2 * e.length, !0), function (e, t, n) {
                    for (var _o3 = 0; _o3 < n.length; _o3++, t += 2) {
                      var _r = Math.max(-1, Math.min(1, n[_o3]));
                      e.setInt16(t, _r < 0 ? 32768 * _r : 32767 * _r, !0);
                    }
                  }(r, 44, e), r;
                }(function (t, n) {
                  if (n == e) return t;
                  if (n > e) throw "downsampling rate show be smaller than original sample rate";
                  var o = e / n,
                    r = Math.round(t.length / o),
                    i = new Float32Array(r),
                    a = 0,
                    s = 0;
                  for (; a < i.length;) {
                    for (var c = Math.round((a + 1) * o), l = 0, u = 0, f = s; f < c && f < t.length; f++) l += t[f], u++;
                    i[a] = l / u, a++, s = c;
                  }
                  return i;
                }(c, n)),
                f = new Blob([u], {
                  type: i
                });
              this.postMessage({
                command: "exportWAV",
                data: f
              });
            }(c.data.type);
            break;
          case "getBuffer":
            !function () {
              var e = [];
              for (var _n = 0; _n < t; _n++) e.push(a(r[_n], o));
              this.postMessage({
                command: "getBuffer",
                data: e
              });
            }();
            break;
          case "clear":
            o = 0, r = [], i();
        }
        var l;
      };
    }, {}), this.worker.postMessage({
      command: "init",
      config: {
        sampleRate: this.context.sampleRate,
        numChannels: this.config.numChannels
      }
    }), this.worker.onmessage = function (e) {
      var t = _this.callbacks[e.data.command].pop();
      "function" == typeof t && t(e.data.data);
    };
  }
  return _createClass(g, [{
    key: "record",
    value: function record() {
      this.recording = !0;
    }
  }, {
    key: "stop",
    value: function stop() {
      this.recording = !1;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.worker.postMessage({
        command: "clear"
      });
    }
  }, {
    key: "getBuffer",
    value: function getBuffer(e) {
      if (!(e = e || this.config.callback)) throw new Error("Callback not set");
      this.callbacks.getBuffer.push(e), this.worker.postMessage({
        command: "getBuffer"
      });
    }
  }, {
    key: "exportWAV",
    value: function exportWAV(e, t) {
      if (t = t || this.config.mimeType, !(e = e || this.config.callback)) throw new Error("Callback not set");
      this.callbacks.exportWAV.push(e), this.worker.postMessage({
        command: "exportWAV",
        type: t
      });
    }
  }], [{
    key: "forceDownload",
    value: function forceDownload(e, t) {
      var n = (window.URL || window.webkitURL).createObjectURL(e),
        o = window.document.createElement("a");
      o.href = n, o.download = t || "output.wav";
      var r = document.createEvent("Event");
      r.initEvent("click", !0, !0), o.dispatchEvent(r);
    }
  }]);
}();
var v,
  m,
  w = g;
function b(_x) {
  return _b.apply(this, arguments);
}
function _b() {
  _b = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var e, t, n, _t2;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          e = _ref.audioContext, t = _ref.errHandler, n = _ref.onStreamLoad;
          _context.prev = 1;
          _context.next = 4;
          return navigator.mediaDevices.getUserMedia({
            audio: !0
          });
        case 4:
          _t2 = _context.sent;
          return _context.abrupt("return", (n && n(), v = _t2, m = e.createMediaStreamSource(_t2), w = new g(m), w.record(), _t2));
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](1);
          console.log(_context.t0), t && t();
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 8]]);
  }));
  return _b.apply(this, arguments);
}
function k(_ref2) {
  var e = _ref2.exportWAV,
    t = _ref2.wavCallback;
  w.stop(), v.getAudioTracks()[0].stop(), e && t && w.exportWAV(function (e) {
    return t(e);
  }), w.clear();
}
var y,
  x = -1 !== navigator.userAgent.indexOf("Edg/"),
  A = window.AudioContext || window.webkitAudioContext,
  C = window.SpeechRecognition || window.webkitSpeechRecognition;
function T(l) {
  var f = this,
    h = l.continuous,
    d = l.crossBrowser,
    p = l.googleApiKey,
    g = l.googleCloudRecognitionConfig,
    v = l.onStartSpeaking,
    m = l.onStoppedSpeaking,
    w = l.speechRecognitionProperties,
    x = l.timeout,
    C = l.useOnlyGoogleCloud,
    T = void 0 !== C && C,
    R = e(!1),
    S = R[0],
    M = R[1],
    U = t(),
    W = e([]),
    E = W[0],
    B = W[1],
    H = e(),
    V = H[0],
    L = H[1],
    O = e(""),
    F = O[0],
    P = O[1],
    j = t(),
    I = t();
  n(function () {
    var e;
    d || y || P("Speech Recognition API is only available on Chrome"), (null === (e = null === navigator || void 0 === navigator ? void 0 : navigator.mediaDevices) || void 0 === e ? void 0 : e.getUserMedia) || P("getUserMedia is not supported on this device/browser :("), !d && !T || p || console.error("No google cloud API key was passed, google API will not be able to process speech"), U.current || (U.current = new A());
  }, []);
  var _ = function _() {
      return r(f, void 0, void 0, function () {
        var e, t, n, o;
        return i(this, function (r) {
          switch (r.label) {
            case 0:
              return !T && y ? (function () {
                if (y) {
                  h && (y.continuous = !0);
                  var e = w || {},
                    t = e.grammars,
                    n = e.interimResults,
                    o = e.lang,
                    r = e.maxAlternatives;
                  t && (y.grammars = t), o && (y.lang = o), y.interimResults = n || !1, y.maxAlternatives = r || 1, y.start(), y.onresult = function (e) {
                    var t = e.results[e.results.length - 1],
                      o = t[0].transcript;
                    if (n) {
                      if (t.isFinal) L(void 0), B(function (e) {
                        return a(e, [o]);
                      });else {
                        for (var r = "", i = e.resultIndex; i < e.results.length; i++) r += e.results[i][0].transcript;
                        L(r);
                      }
                    } else B(function (e) {
                      return a(e, [o]);
                    });
                  }, y.onaudiostart = function () {
                    return M(!0);
                  }, y.onend = function () {
                    M(!1);
                  };
                }
              }(), [2]) : d || T ? ("suspended" === (null === (n = U.current) || void 0 === n ? void 0 : n.state) && (null === (o = U.current) || void 0 === o || o.resume()), [4, b({
                errHandler: function errHandler() {
                  return P("Microphone permission was denied");
                },
                audioContext: U.current
              })]) : [2];
            case 1:
              return e = r.sent(), x && D(), I.current && I.current.getAudioTracks()[0].stop(), I.current = e.clone(), (t = function (e, t) {
                var n = new c();
                if (!s) return n;
                var o,
                  r,
                  i,
                  a = (t = t || {}).smoothing || .1,
                  l = t.interval || 50,
                  f = t.threshold,
                  h = t.play,
                  d = t.history || 10,
                  p = !0;
                u = t.audioContext || u || new s(), (i = u.createAnalyser()).fftSize = 512, i.smoothingTimeConstant = a, r = new Float32Array(i.frequencyBinCount), e.jquery && (e = e[0]), e instanceof HTMLAudioElement || e instanceof HTMLVideoElement ? (o = u.createMediaElementSource(e), void 0 === h && (h = !0), f = f || -50) : (o = u.createMediaStreamSource(e), f = f || -50), o.connect(i), h && i.connect(u.destination), n.speaking = !1, n.suspend = function () {
                  return u.suspend();
                }, n.resume = function () {
                  return u.resume();
                }, Object.defineProperty(n, "state", {
                  get: function get() {
                    return u.state;
                  }
                }), u.onstatechange = function () {
                  n.emit("state_change", u.state);
                }, n.setThreshold = function (e) {
                  f = e;
                }, n.setInterval = function (e) {
                  l = e;
                }, n.stop = function () {
                  p = !1, n.emit("volume_change", -100, f), n.speaking && (n.speaking = !1, n.emit("stopped_speaking")), i.disconnect(), o.disconnect();
                }, n.speakingHistory = [];
                for (var g = 0; g < d; g++) n.speakingHistory.push(0);
                var _v = function v() {
                  setTimeout(function () {
                    if (p) {
                      var e = function (e, t) {
                        var n = -1 / 0;
                        e.getFloatFrequencyData(t);
                        for (var o = 4, r = t.length; o < r; o++) t[o] > n && t[o] < 0 && (n = t[o]);
                        return n;
                      }(i, r);
                      n.emit("volume_change", e, f);
                      var t = 0;
                      if (e > f && !n.speaking) {
                        for (var o = n.speakingHistory.length - 3; o < n.speakingHistory.length; o++) t += n.speakingHistory[o];
                        t >= 2 && (n.speaking = !0, n.emit("speaking"));
                      } else if (e < f && n.speaking) {
                        for (o = 0; o < n.speakingHistory.length; o++) t += n.speakingHistory[o];
                        0 == t && (n.speaking = !1, n.emit("stopped_speaking"));
                      }
                      n.speakingHistory.shift(), n.speakingHistory.push(0 + (e > f)), _v();
                    }
                  }, l);
                };
                return _v(), n;
              }(I.current, {
                audioContext: U.current
              })).on("speaking", function () {
                v && v(), clearTimeout(j.current);
              }), t.on("stopped_speaking", function () {
                var e;
                m && m(), M(!1), null === (e = I.current) || void 0 === e || e.getAudioTracks()[0].stop(), k({
                  exportWAV: !0,
                  wavCallback: function wavCallback(e) {
                    return N({
                      blob: e,
                      continuous: h || !1
                    });
                  }
                });
              }), M(!0), [2];
          }
        });
      });
    },
    D = function D() {
      j.current = window.setTimeout(function () {
        var e;
        M(!1), null === (e = I.current) || void 0 === e || e.getAudioTracks()[0].stop(), k({
          exportWAV: !1
        });
      }, x);
    },
    N = function N(e) {
      var t = e.blob,
        n = e.continuous,
        s = new FileReader();
      s.readAsDataURL(t), s.onloadend = function () {
        return r(f, void 0, void 0, function () {
          var e, t, r, c, l, u, f, h;
          return i(this, function (i) {
            switch (i.label) {
              case 0:
                return e = s.result, (t = null === (f = U.current) || void 0 === f ? void 0 : f.sampleRate) && t > 48e3 && (t = 48e3), r = {
                  content: ""
                }, c = _o({
                  encoding: "LINEAR16",
                  languageCode: "en-US",
                  sampleRateHertz: t
                }, g), l = {
                  config: c,
                  audio: r
                }, r.content = e.substr(e.indexOf(",") + 1), [4, fetch("https://speech.googleapis.com/v1/speech:recognize?key=" + p, {
                  method: "POST",
                  body: JSON.stringify(l)
                })];
              case 1:
                return [4, i.sent().json()];
              case 2:
                return u = i.sent(), (null === (h = u.results) || void 0 === h ? void 0 : h.length) > 0 && B(function (e) {
                  return a(e, [u.results[0].alternatives[0].transcript]);
                }), n && _(), [2];
            }
          });
        });
      };
    };
  return {
    error: F,
    interimResult: V,
    isRecording: S,
    results: E,
    startSpeechToText: _,
    stopSpeechToText: function stopSpeechToText() {
      var e;
      y && !T ? y.stop() : (M(!1), null === (e = I.current) || void 0 === e || e.getAudioTracks()[0].stop(), k({
        exportWAV: !0,
        wavCallback: function wavCallback(e) {
          return N({
            blob: e,
            continuous: !1
          });
        }
      }));
    }
  };
}
navigator.brave && navigator.brave.isBrave().then(function (e) {
  e && (y = null);
}), !x && C && (y = new C());
export default T;